export default "__VITE_ASSET__4dd4efb7__"